module.exports = __webpack_public_path__ + "img/china_telecom_icon.b9315ddf.svg";